export function promoCodePath(codeName: string) {
  return `/promos/code/${encodeURIComponent(codeName)}`;
}

export function promoIdPath(promoId: string) {
  return `/promos/${encodeURIComponent(promoId)}`;
}
